class InactivityTimeout {
    constructor(timeoutDuration, logoutCallback) {
        this.timeoutDuration = timeoutDuration;
        this.logoutCallback = logoutCallback;
        this.inactivityTimeout = null;
        this.lastActivityAt = Date.now();
        this.hasTimedOut = false;

        this._onActivity = () => this.resetInactivityTimer();
        this._checkInactivity = () => this.checkInactivity();

        this.startInactivityTimer();
        this.setupEventListeners();
    }

    startInactivityTimer() {
        this.clearInactivityTimer();
        const remaining = Math.max(0, this.timeoutDuration - (Date.now() - this.lastActivityAt));
        this.inactivityTimeout = setTimeout(this._checkInactivity, remaining);
    }

    resetInactivityTimer() {
        if (this.hasTimedOut) return;
        if (Date.now() - this.lastActivityAt >= this.timeoutDuration) {
            this.checkInactivity();
            return;
        }
        this.lastActivityAt = Date.now();
        this.startInactivityTimer();
    }

    checkInactivity() {
        if (this.hasTimedOut) return;
        if (Date.now() - this.lastActivityAt < this.timeoutDuration) {
            this.startInactivityTimer();
            return;
        }
        this.hasTimedOut = true;
        this.clearInactivityTimer();
        this.logoutCallback();
    }

    clearInactivityTimer() {
        clearTimeout(this.inactivityTimeout);
    }

    setupEventListeners() {
        ['mousemove', 'keydown', 'pointerdown', 'touchstart', 'wheel'].forEach((event) => {
            document.addEventListener(event, this._onActivity);
        });
        document.addEventListener('visibilitychange', this._checkInactivity);
        window.addEventListener('focus', this._checkInactivity);
    }

    destroy() {
        this.clearInactivityTimer();
        ['mousemove', 'keydown', 'pointerdown', 'touchstart', 'wheel'].forEach((event) => {
            document.removeEventListener(event, this._onActivity);
        });
        document.removeEventListener('visibilitychange', this._checkInactivity);
        window.removeEventListener('focus', this._checkInactivity);
    }
}

export default InactivityTimeout;
